<div [formGroup]="group" class="grid grid-cols-1 md:grid-cols-2 gap-4">
  <div class="flex flex-col gap-1">
    <label class="block text-sm font-medium text-gray-600">Password</label>
    <p-password
      formControlName="password"
      [feedback]="true"
      [toggleMask]="true"
      styleClass="w-full"
      inputStyleClass="w-full"
      placeholder="Nuova password"
      promptLabel="Inserisci una password"
      weakLabel="Debole"
      mediumLabel="Media"
      strongLabel="Forte"
    />
    <small
      class="p-error"
      *ngIf="group.get('password')?.invalid && group.get('password')?.touched"
    >
      La password deve contenere almeno 6 caratteri
    </small>
  </div>

  <div class="flex flex-col gap-1">
    <label class="block text-sm font-medium text-gray-600">Conferma Password</label>
    <p-password
      [formControlName]="confirmControlName"
      [feedback]="false"
      [toggleMask]="true"
      styleClass="w-full"
      inputStyleClass="w-full"
      placeholder="Ripeti la password"
    />
    <small
      class="p-error"
      *ngIf="group.errors?.['passwordMismatch'] && group.get(confirmControlName)?.touched"
    >
      Le password non corrispondono
    </small>
  </div>
</div>
